import React from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import styles from './govtIdCaptureScreen.module.css';

import { ReactComponent as ChevronRight } from 'asset/IconsPack/at_chevron-right-filled.svg';

import { GOVT_ID_COPY } from '../../helper/constants';

const AcceptedDocuments = ({ inline, labels }) =>
    inline ? (
        <Box className={styles.documents}>
            <Typography className={styles.documentsLabel}>
                {GOVT_ID_COPY.ACCEPTED_DOCUMENTS}
            </Typography>
            <Typography className={styles.documentsList}>{labels.join(', ')}</Typography>
        </Box>
    ) : (
        <Box className={styles.documents}>
            <Box className={styles.documentsToggle}>
                <ChevronRight className={styles.documentsChevron} />
                <Typography className={styles.documentsToggleText}>
                    {GOVT_ID_COPY.ACCEPTED_DOCUMENTS_TOGGLE}
                </Typography>
            </Box>
        </Box>
    );

AcceptedDocuments.propTypes = {
    inline: PropTypes.bool.isRequired,
    labels: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default AcceptedDocuments;
